export const WEBAPP_HOST = process.env.REACT_APP_WEBAPP_HOST;
export const FACEBOOK_ID = process.env.REACT_APP_FACEBOOK_ID;
export const STRIPE_SCRIPT_URL = process.env.REACT_APP_STRIPE_SCRIPT_URL;
export const WEB_DOMAIN = process.env.REACT_APP_WEB_DOMAIN;
export const FILTER_API_HOST = process.env.REACT_APP_FILTER_API_HOST;
export const SEARCH_API_HOST = process.env.REACT_APP_SEARCH_API_HOST;
export const WEB_INSIGHTTIMER_INTERNAL_LINK = 'https://web.insighttimer.com';
export const WIDGET_HOST = 'https://widgets.insighttimer.com';

export const TEACHER_INSIGHTTIMER_LINK = 'https://teacher.insighttimer.com';

export const RETREAT_PATHS = [
  'https://web-retreats--insight-timer-a1ac7.us-east4.hosted.app/retreats',
  'https://funnel-staging.insighttimer.com/retreats',
  `${WEBAPP_HOST}/retreats`
];

export const ERROR_MESSAGES = {
  name_required: 'Full Name is required.',
  email_required: 'Email is required.',
  email_registered: 'Email is already registered.',
  email_wrong_format: 'Email is invalid.',
  password_required: 'Password is required.',
  password_min_required: 'Password minimum 6 chars.',
  password_alpha_required:
    'Only alphanumeric and . , + = ! ? ( ) [ ] characters allowed.',
  register_failed: 'Register failed, please try again later.',
  login_failed: 'Login failed, please try again later.',
  login_incorrect: 'Email or password is incorrect.',
  facebook_failed: 'Failed to login with facebook.'
};
